export const CATEGORIES_GET = 'CATEGORIES_GET';
export const CATEGORY_ADD = 'CATEGORY_ADD';
export const CATEGORY_EDIT = 'CATEGORY_EDIT';
export const CATEGORY_GET = 'CATEGORY_GET';
export const CATEGORY_DELETE = 'CATEGORY_DELETE';
